import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { routes } from 'core/routing';
import manager from 'core/user/manager';
import { useUser } from 'core/user/user';

const RETURN_URL_KEY = 'return-url';

const saveReturnUrl = (url) => localStorage.setItem(RETURN_URL_KEY, url);

const getReturnUrl = () => localStorage.getItem(RETURN_URL_KEY) || null;

const deleteReturnUrl = () => localStorage.removeItem(RETURN_URL_KEY);

export const useAuthController = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { reset: resetUser } = useUser();

  const handleLogin = useCallback((url = null) => {
    saveReturnUrl(url ?? pathname);
    void manager.signinRedirect();
  }, []);

  const handleCompleteLogin = useCallback(() => {
    manager.signinRedirectCallback().then(() => {
      const returnUrl = getReturnUrl() ?? routes.landing();

      deleteReturnUrl();

      window.location.href = returnUrl;
    });
  }, []);

  const handleLogout = useCallback(() => {
    manager.removeUser().then(() => {
      resetUser();
      navigate(routes.landing());
    });
  }, []);

  return {
    login: handleLogin,
    completeLogin: handleCompleteLogin,
    logout: handleLogout
  };
};
